module.exports = __webpack_public_path__ + "media/images/flag_uk-990990defe190fe048134b346512dc38.png";